/*
import { Injectable } from '@angular/core';
import { Router} from '@angular/router';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

interface Alert {
  message: string;
  type: string;
  dimissible?: boolean
}

@Injectable({
  providedIn: 'root'
})
export class AlertService {
 private alertSubject = new Subject<Alert>();

      onAlert(): Observable<Alert> {
        return this.alertSubject.asObservable();
      }

      showAlert(message: string, type: string = 'info', dismissible: boolean = false): void {
        this.alertSubject.next({ message, type });

  }
}
*/

// alert.service.ts
import { MatSnackBar } from '@angular/material/snack-bar';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class AlertService
{
    currentAlert: any;

    constructor(private _snackBar: MatSnackBar) {}

    showSnackbar(message: string) {
        this._snackBar.open(message, 'Dismiss', {
            duration: 10000, // Duration in milliseconds
            direction: 'rtl',
            verticalPosition: 'top',
        });
    }
}
